
<div class="mail-attachment-list" v-if="attachments && attachments.length > 0">
    <div v-for="(attachment, index) in attachments" :key="index" class="mail-attachment" style="display: flex">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind = "attrs"
                    v-on   = "on"
                    style  = "display: flex; width: 100%"
                >
                    <p-dms-icon
                        :icon="icon(attachment)" style="margin-top: 2px; padding-right: 4px;" />
                    <div style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: calc(100% - 25px)">{{ attachment.name }}</div>
                </div>
            </template>

            <div style="display: flex">
                <p-dms-icon
                    :icon="icon(attachment)"
                    style="margin-top: 2px; padding-right: 4px;"
                />
                <div>
                    {{ attachment.name }}
                </div>
            </div>
        </v-tooltip>
    </div>
</div>
